var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParityLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89.1 91.6",
    style: {
      enableBackground: "new 0 0 89.1 91.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#16BCC8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,46.2l62.7,1.7c2.6,0.1,4.3,2.7,3.3,5.1l-4.2,9.6c-0.6,1.3-1.9,2.2-3.4,2.2l-63.3-0.3 c-2.6,0-4.4-2.7-3.3-5.1l4.8-11C18.6,47.1,20,46.2,21.4,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,63.8L33.7,17.2c-0.9-1-1.2-2.4-0.6-3.6l4.4-10.3c0.9-2.2,3.8-2.7,5.4-1L87,49c0.9,1,1.2,2.4,0.6,3.6 l-4.4,10.2C82.3,65,79.5,65.5,77.8,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,72l62.9,1.7c2.6,0.1,4.4,2.8,3.3,5.2L72,88.7c-0.5,1.2-1.6,1.9-2.9,1.9L4.7,90.2c-2.3,0-3.8-2.3-2.9-4.4 L7,73.9C7.5,72.7,8.7,72,10,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,89.5L22.6,43c-0.9-1-1.2-2.4-0.6-3.6l4.4-10.3c0.9-2.2,3.8-2.7,5.4-1l44.1,46.6c0.9,1,1.2,2.4,0.6,3.6 l-4.4,10.2C71.2,90.7,68.4,91.2,66.7,89.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParityLogoDark);
export default __webpack_public_path__ + "static/media/parity-logo-dark.a40a8f147b8185e9e827c2a2a87c8769.svg";
export { ForwardRef as ReactComponent };